export var ErrorStateTestIds = {
    /** Test ID to grab the title */
    TITLE: 'hawkins-error-state-title',
    /** Test ID to grab the subtitle */
    SUBTITLE: 'hawkins-error-state-subtitle',
};
